module.exports = __webpack_public_path__ + "img/automation.439c87ae.svg";